import type { Tenant } from '@/common/overmind/namespaces/tenants';

import type { GUID } from '../auth';

export class SelectedTenant {
  private _tenantId: GUID | null;
  constructor(tenantId: GUID | null) {
    this._tenantId = tenantId;
  }

  availableIn(tenantIds: Tenant[]) {
    return (
      this._tenantId && tenantIds.find(tenant => tenant.id === this._tenantId)
    );
  }

  toGuid() {
    return this._tenantId as any as GUID;
  }
}

export type IStorage = {
  setItem: (key: string, value: any) => void;
  getItem: <T>(key: string) => T | null;
};

export type SelectTenantEffectContext = {
  storage: IStorage;
};

let _options: SelectTenantEffectContext | null = null;
export const selectedTenant = {
  initialize: (options: SelectTenantEffectContext) => {
    _options = options;
  },
  save(selectedTenant: { tenantId: string; applicationId: string }) {
    ensureInitialized();
    localStorage.setItem(
      selectedTenantKey(selectedTenant),
      selectedTenant.tenantId
    );
    return Promise.resolve();
  },
  readPreviouslySelected(context: { applicationId: string }) {
    ensureInitialized();
    return Promise.resolve(
      new SelectedTenant(
        localStorage.getItem(selectedTenantKey(context)) as GUID
      )
    );
  }
};
function ensureInitialized() {
  if (!_options) throw Error('[effect: selectedTenant]: not initialized!');
}

function selectedTenantKey(selectedTenant: { applicationId: string }): string {
  return `gridCalculator.${selectedTenant.applicationId}.selectedTenant.Id`;
}
